const Cookies = require("js-cookie");

export function getCurrency() {
  let currencyCode = Cookies.get("currency") || "USD";
  return currencyCode;
}
